import { useEffect, useState } from 'react';

const navLinks = [
  { id: 'schedule', label: '蹲瓜时间表' },
  { id: 'flash', label: '最新快讯' },
  { id: 'hot', label: '热门大瓜榜' },
  { id: 'columns', label: '栏目专区' },
  { id: 'guide', label: '吃瓜指南' },
  { id: 'about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-[0_6px_24px_-18px_rgba(60,30,20,0.6)]' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-[72px] md:px-6">
        <a href="#top" onClick={scrollTo('top')} className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
            大瓜<span className="text-primary-600">预警</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={scrollTo(link.id)}
              className="whitespace-nowrap rounded-md px-3 py-2 text-[15px] text-foreground-700 transition hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            onClick={scrollTo('subscribe')}
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-notification-3-line" />
            订阅蹲位
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition hover:bg-background-100 lg:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/98 px-4 pb-4 pt-2 lg:hidden">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={scrollTo(link.id)}
              className="block rounded-md px-3 py-3 text-base text-foreground-800 transition hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={scrollTo('subscribe')}
            className="mt-2 flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-notification-3-line" />
            订阅蹲位
          </a>
        </div>
      )}
    </header>
  );
}